<template>
  <v-main class="pt-7">
    <v-container>
      <div class="base-container">
        <v-row align="center" justify="space-between" no-gutters>
          <v-col cols="12" md="4" class="d-flex align-center justify-center">
            <h3 class="secondary-font text--secondary py-5">
              Rede de benefícios
            </h3>
          </v-col>

          <v-col
            v-for="(item, n) in items"
            :key="n"
            align="center"
            cols="12"
            md="4"
            class="pb-0 d-flex align-center justify-center"
          >
            <div>
              <div class="ma-8 icon-pag-default">
                <v-icon x-large color="item.color" class="white--text" v-text="item.icon"></v-icon>
              </div>
              <h2 class="primary--text d-flex pa-4 align-content-center align-center justify-center">
                Em breve uma rede de benefícios para você e sua família.
              </h2>
            </div>
          </v-col>
        </v-row>
        <v-row no-gutters class="h-90">
          <v-col cols="12"> </v-col>
        </v-row>
      </div>
    </v-container>
  </v-main>
</template>

<script>
export default {
  data: () => ({
    items: [
      {
        color: 'white',
        icon: 'mdi-google-circles-extended',
        title: 'Upload de atestado '
      }
    ]
  })
}
</script>

<style>
.icon-pag-default {
  width: 140px;
  height: 140px;
  display: flex;
  justify-content: center;
  flex-flow: wrap;
  position: relative;
}
.icon-pag-default i {
  font-size: 2em;
  color: #fff;
}
.icon-pag-default::before {
  content: ' ';
  width: 140px;
  height: 140px;
  position: absolute;
  border-radius: 100%;
  background: blue;
}
</style>
